import { PayloadAction } from "@reduxjs/toolkit";
import {
  ADDON_DETAILS,
  COMMON_DROPDOWN_DATA,
  THealthAddForm,
  THealthSlice,
} from "../../../Type/Health/THealthSlice/THealthSlice";
import { THealthFormResponse } from "../../../Type/Health/Form/THealthFormResponse";
import { THealthQuote } from "../../../Type/Health/Form/THealthquote";
import { THealthBuyActionResopnse } from "../../../Type/Health/Form/THelathBuyactionResponse";
import { TDropdown } from "../../../Type/Common/TDropdown";

function BULK_UPLOAD(state: THealthSlice, action: PayloadAction<THealthSlice>) {
  const data: THealthSlice = { ...state, ...action.payload };

  return data;
}
function SET_HEALTH_SLICE(
  state: THealthSlice,
  action: PayloadAction<THealthSlice>
) {
  let data: THealthSlice = action.payload;
  return data;
}

function setAddFormData(
  state: THealthSlice,
  action: PayloadAction<THealthAddForm>
) {
  return {
    ...state,
    ADD_FORM: { ...action.payload },
  };
}

function updateMultipleKeysInAddForm(
  state: THealthSlice,
  action: PayloadAction<Partial<THealthSlice["ADD_FORM"]>>
) {
  state.ADD_FORM = {
    ...state.ADD_FORM,
    ...action.payload,
  };
}

function updateMultipleKeysInAddFormResponse(
  state: THealthSlice,
  action: PayloadAction<Partial<THealthSlice["ADD_FORM_RESPONSE"]>>
) {
  state.ADD_FORM_RESPONSE = {
    ...state.ADD_FORM_RESPONSE,
    ...action.payload,
  };
}

function setAddFormResponse(
  state: THealthSlice,
  action: PayloadAction<THealthFormResponse>
) {
  return { ...state, ADD_FORM_RESPONSE: action.payload };
}

function setAddFormResponseUpdateOneKey(
  state: THealthSlice,
  action: PayloadAction<{ key: keyof THealthFormResponse; value: any }>
) {
  const { key, value } = action.payload;
  return {
    ...state,
    ADD_FORM_RESPONSE: {
      ...state.ADD_FORM_RESPONSE,
      [key]: value,
    },
  };
}

const SAVE_ALL_QUOTES_DATA = (
  state: THealthSlice,
  action: PayloadAction<THealthQuote[]>
) => {
  const data = {
    ...state,
    ALL_QUOTES_DATA: action.payload,
  };

  return data;
};

const SAVE_SELECTED_QUOTE_DATA = (
  state: THealthSlice,
  action: PayloadAction<THealthQuote>
) => {
  const data = {
    ...state,
    SELECTED_QUOTE_DATA: action.payload,
  };

  return data;
};

const SAVE_BUYACTION_RESPONSE_DATA = (
  state: THealthSlice,
  action: PayloadAction<THealthBuyActionResopnse>
) => {
  const data = {
    ...state,
    BUYACTION_RESPONSE_DATA: action.payload,
  };

  return data;
};

const SAVE_MEDICAL_QUESTION_DATA_IIFCO = (
  state: THealthSlice,
  action: PayloadAction<any>
) => {
  const data = {
    ...state,
    MEDICAL_QUESTION_DATA_IIFCO: action.payload,
  };

  return data;
};
const SAVE_MEDICAL_QUESTION_DATA_ICIC = (
  state: THealthSlice,
  action: PayloadAction<any>
) => {
  const data = {
    ...state,
    MEDICAL_QUESTION_DATA_IIFCO: action.payload,
  };

  return data;
};
const SAVE_MEDICAL_QUESTION_DATA_GO_DIGIT = (
  state: THealthSlice,
  action: PayloadAction<any>
) => {
  const data = {
    ...state,
    MEDICAL_QUESTION_DATA_GO_DIGIT: action.payload,
  };

  return data;
};
const SAVE_MEDICAL_QUESTION_DATA_FUTURE_GENERALI = (
  state: THealthSlice,
  action: PayloadAction<any>
) => {
  const data = {
    ...state,
    MEDICAL_QUESTION_DATA_FUTURE_GENERALI: action.payload,
  };

  return data;
};
const SAVE_MEDICAL_QUESTION_DATA_CARE = (
  state: THealthSlice,
  action: PayloadAction<any>
) => {
  const data = {
    ...state,
    MEDICAL_QUESTION_DATA_CARE: action.payload,
  };

  return data;
};
const SAVE_MEDICAL_QUESTION_DATA_STAR = (
  state: THealthSlice,
  action: PayloadAction<any>
) => {
  const data = {
    ...state,
    MEDICAL_QUESTION_DATA_STAR: action.payload,
  };

  return data;
};

const UPDATE_QUOTE_LOADER_STATUS = (
  state: THealthSlice,
  action: PayloadAction<boolean>
) => {
  const data = {
    ...state,

    QUOTE_LOADER: action.payload,
  };

  return data;
};
const CHANGE_PAGE_STATUS = (
  state: THealthSlice,
  action: PayloadAction<boolean>
) => {
  const data = {
    ...state,

    PAGE_STATUS: action.payload,
  };

  return data;
};

type COMMON_DROPDOWN_DATA_API = keyof COMMON_DROPDOWN_DATA;
const HEALTH_DROPDOWNDATA = (
  state: THealthSlice,
  action: PayloadAction<{ key: COMMON_DROPDOWN_DATA_API; value: TDropdown[] }>
) => {
  const { key, value } = action.payload;
  let data = { ...state };
  data = {
    ...state,
    DROPDOWN_DATA: {
      ...state.DROPDOWN_DATA,
      [key]: value,
    },
  };
  return data;
};

const CHANGE_NOMINEE_STATUS = (
  state: THealthSlice,
  action: PayloadAction<"ADULT_2" | "OTHER">
) => {
  let data = { ...state };
  console.log("action.payload", action.payload);
  data = {
    ...state,
    NOMINEE_RELATIONSHIP_STATUS: action.payload,
  };
  return data;
};
const ADDON_DETAILS_DATA = (
  state: THealthSlice,
  action: PayloadAction<ADDON_DETAILS>
) => {
  console.log("action.payload", action.payload);
  let data = { ...state };
  data = {
    ...data,
    ADDON_DETAILS: action.payload,
  };
  return data;
};
const PREVIEW_LOADER = (
  state: THealthSlice,
  action: PayloadAction<boolean>
) => {
  let data = { ...state };
  data = {
    ...data,
    Preview_Loader: action.payload,
  };
  return data;
};
export const HEALTH_REDUCERS = {
  BULK_UPLOAD,
  SET_HEALTH_SLICE,
  setAddFormData,
  setAddFormResponse,
  SAVE_ALL_QUOTES_DATA,
  ADDON_DETAILS_DATA,
  PREVIEW_LOADER,
  SAVE_BUYACTION_RESPONSE_DATA,
  SAVE_MEDICAL_QUESTION_DATA_IIFCO,
  SAVE_MEDICAL_QUESTION_DATA_GO_DIGIT,
  SAVE_MEDICAL_QUESTION_DATA_FUTURE_GENERALI,
  SAVE_MEDICAL_QUESTION_DATA_STAR,
  SAVE_MEDICAL_QUESTION_DATA_CARE,
  SAVE_MEDICAL_QUESTION_DATA_ICIC,
  HEALTH_DROPDOWNDATA,
  SAVE_SELECTED_QUOTE_DATA,
  CHANGE_PAGE_STATUS,
  CHANGE_NOMINEE_STATUS,
  UPDATE_QUOTE_LOADER_STATUS,
  setAddFormResponseUpdateOneKey,
  updateMultipleKeysInAddForm,
  updateMultipleKeysInAddFormResponse,
};

export type HealthReducers = typeof HEALTH_REDUCERS;
